export default __webpack_public_path__ + "static/media/quiz_card.04a68023.svg";